import React, { useContext } from "react";
import { useState, useEffect } from "react";
// import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { Select2Data } from "../../../../utils/common";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import { Container } from "react-bootstrap";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);

  const id = props.show;
  const [, setCountry] = useState([]);
  const [, setStates] = useState([]);
  const [, setCities] = useState([]);
  const [, setPincode] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  // console.log(showModal, "showModal showModal");

  const GetEditData = async () => {
    const response = await getData(`/masters/investor/${id}`);
    reset(response?.data);
  };

  const GetAllCountries = async () => {
    const response = await getData("/without-login/masters/all-country");

    if (response?.success) {
      setCountry(await Select2Data(response?.data, "country_id"));
    }
  };

  const GetAllStates = async (id) => {
    const response = await getData(`/without-login/masters/all-states/${id}`);

    if (response?.success) {
      setStates(await Select2Data(response?.data, "state_id"));
    }
  };

  const GetAllCities = async (id) => {
    const response = await getData(`/without-login/masters/all-city/${id}`);

    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };
  const GetAllPincode = async () => {
    const response = await getData(`/without-login/masters/all-occupation`);

    if (response?.success) {
      setPincode(await Select2Data(response?.data, "pincode_id"));
    }
  };

  useEffect(() => {
    GetAllPincode();
    GetEditData();
    GetAllCountries();
    GetAllStates();
    GetAllCities();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();

      finalData.append("f_name", data.f_name);
      finalData.append("contact_no", data.contact_no);
      finalData.append("email", data.email);
      const response = await postData(`/masters/investor/${id}`, finalData);

      if (response.success) {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal(0);
          props.handleClose();
        }, 3000);
      } else {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal(0);
          props.handleClose();
        }, 2000);
      }
    } catch (error) {
      console.error(error);
    }
    // if (data.re_password === data.c_password) {

    // } else {
    //   setError("password", {
    //     message: "Passwords must match",
    //   });
    // }
  };

  // console.log(getValues(), "ggggggggggggggggggggg");

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add FAQ</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded ">
            <Card.Body>
              <Card.Title>Edit Employee</Card.Title>
              <hr />
              <Container>
                <Form
                  onSubmit={() => handleSubmit(onSubmit)}
                  role="form"
                  // className="stateclass"
                >
                  <Row>
                    <Col md={6}>
                      <div className="main-form-section my-3">
                        <Form.Group>
                          <div className="">
                            <Form.Label>Name</Form.Label>
                          </div>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              name="f_name"
                              placeholder="Name"
                              className={classNames("", {
                                "is-invalid": errors?.f_name,
                              })}
                              {...register("f_name", {
                                required: "Name is required",
                              })}
                            />
                          </InputGroup>
                          {errors.f_name && (
                            <span className="text-danger">
                              {errors.f_name.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section my-3">
                        <Form.Group>
                          <div className="">
                            <Form.Label>Contact</Form.Label>
                          </div>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              name="contact_no"
                              placeholder="Brand"
                              className={classNames("", {
                                "is-invalid": errors?.contact_no,
                              })}
                              {...register("contact_no", {
                                required: "contact_no is required",
                                minLength: {
                                  value: 10,
                                  message:
                                    "Number should be at least 10 characters",
                                },
                              })}
                              onKeyDown={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  if (event.key !== "Backspace") {
                                    event.preventDefault();
                                  }
                                }
                              }}
                              maxLength={10}
                            />
                          </InputGroup>
                          {errors.contact_no && (
                            <span className="text-danger">
                              {errors.contact_no.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="main-form-section my-3">
                        <Form.Group>
                          <div className="">
                            <Form.Label>Email</Form.Label>
                          </div>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              name="email"
                              placeholder="email"
                              className={classNames("", {
                                "is-invalid": errors?.email,
                              })}
                              {...register("email", {
                                required: "email is required",
                                pattern: {
                                  value:
                                    /^([A-Za-z0-9_\-.])+@(?!(?:[A-Za-z0-9_\-.]+\.)?([A-Za-z0-9_\-.]+)\.\2)([A-Za-z0-9_\-.]+\.)+([A-Za-z]{2,4})$/,
                                  message: "Email Id Invalid",
                                },
                              })}
                            />
                          </InputGroup>
                          {errors.email && (
                            <span className="text-danger">
                              {errors.email.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    {/* <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Last Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="l_name"
                        placeholder="Last Name"
                        className={classNames("", {
                          "is-invalid": errors?.l_name,
                        })}
                        {...register("l_name", {
                          required: "Last Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.l_name && (
                      <span className="text-danger">
                        {errors.l_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

                    <Row className="mt-5 pb-3">
                      <div className="d-flex justify-content-center">
                        <Link>
                          <CancelButton
                            name={"cancel"}
                            handleClose={props.handleClose}
                          />
                        </Link>

                        <SaveButton
                          name={"save"}
                          handleSubmit={handleSubmit(onSubmit)}
                        />
                      </div>
                    </Row>
                  </Row>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
